module.exports = __webpack_public_path__ + "img/icon-deskripsi.d63e76eb.svg";